/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';

const normalizePropertyName = (propertyName: string): string =>
  propertyName.startsWith('.') ? propertyName.slice(1) : propertyName;

// Fallback rule when metadata has no label/caption: always use the leaf segment.
const resolveFallbackLabel = (propertyLeaf: string): string => {
  const lastDotIndex = propertyLeaf.lastIndexOf('.');
  return lastDotIndex < 0 ? propertyLeaf : propertyLeaf.slice(lastDotIndex + 1);
};

AnnotationsHandler.registerHandler('@FL', (propertyName: string, c11nEnv: C11nEnv) => {
  const propertyLeaf = normalizePropertyName(propertyName);
  const fieldMetadata = c11nEnv.getFieldMetadata(propertyLeaf);

  if (!fieldMetadata) return resolveFallbackLabel(propertyLeaf);
  if (!fieldMetadata.label) return resolveFallbackLabel(propertyLeaf);

  return c11nEnv.getLocalizationService(fieldMetadata.localeReference).getLocalizedText(fieldMetadata.label);
});
